export const SET_USER_IS_LOGGED = "SET_USER_IS_LOGGED";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const HANDLE_FETCH_CURRENT_USER = "HANDLE_FETCH_CURRENT_USER";
export const HANDLE_FETCH_ONLY_CURRENT_USER = "HANDLE_FETCH_ONLY_CURRENT_USER";
export const SET_AUTHORIZED_STATUS = "SET_AUTHORIZED_STATUS";
export const SET_USER_AVATAR = "SET_USER_AVATAR";
export const HANDLE_CHANGE_PASSWORD = "HANDLE_CHANGE_PASSWORD";
export const HANDLE_REQUEST_RESET_PASSWORD = "HANDLE_REQUEST_RESET_PASSWORD";
export const SHOW_WELCOME_MODAL = "SHOW_WELCOME_MODAL";

/* ==== REFACTORED ===== */
export const HANDLE_UPDATE_LAST_VERSION_SEEN = "HANDLE_UPDATE_LAST_VERSION_SEEN";

export interface IHandleUpdateLastVersionSeen {
  type: typeof HANDLE_UPDATE_LAST_VERSION_SEEN;
  payload: LastVersionSeenRequest;
}

export const HANDLE_IMPERSONATE = "HANDLE_IMPERSONATE";

export interface IHandleImpersonate {
  type: typeof HANDLE_IMPERSONATE;
  payload: ImpersonatePayload;
}

export const HANDLE_LOGOUT = "HANDLE_LOGOUT";

export interface IHandleLogout {
  type: typeof HANDLE_LOGOUT;
}

export const HANDLE_LOGIN = "HANDLE_LOGIN";

export interface IHandleLogin {
  type: typeof HANDLE_LOGIN;
  payload: LoginPayload;
}

export const HANDLE_UPDATE_USER_PROFILE = "HANDLE_UPDATE_USER_PROFILE";

export interface IHandleUpdateUserProfile {
  type: typeof HANDLE_UPDATE_USER_PROFILE;
  payload: {
    user: User;
    avatar: Blob;
  };
}

export const HANDLE_UPDATE_USER_AVATAR = "HANDLE_UPDATE_AVATAR";

export interface IHandleUpdateAvatar {
  type: typeof HANDLE_UPDATE_USER_AVATAR;
  payload: {
    user_id: string;
    avatar: Blob;
  };
}
